/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Lots_Col_CodeInputs */

const vi_pl_lots_col_code = /** @type {(inputs: Pl_Lots_Col_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã lô`)
};

/**

* @param {Pl_Lots_Col_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_lots_col_code = /** @type {((inputs?: Pl_Lots_Col_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Lots_Col_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_lots_col_code(inputs)
});